import React from 'react'

export const PersonContext = React.createContext({})

export default function PersonContextProvider({ value, children }) {
  return <PersonContext.Provider value={value}>{children}</PersonContext.Provider>
}
